// Utils
import { toTitleCase, toSentenceCase } from '../textFormatter';

function estructurarDatos(data) {
  return {
    numeroOT: data.numeroOT,
    cliente: {
      nombre: toTitleCase(data.cliente_nombre) || '',
      rut: data.cliente_rut || '',
      correo: data.cliente_correo.toLowerCase() || '',
      celular: data.cliente_celular || ''
    },
    vehiculo: {
      fechaIngreso: data.fechaIngreso.split('T')[0] || '',
      fechaSalida: data.fechaSalida.split('T')[0] || '',
      patente: data.patente.toUpperCase() || '',
      marca: toTitleCase(data.marca) || '',
      modelo: toTitleCase(data.modelo) || '',
      anio: data.anio || '',
      nmotor: data.nmotor.toUpperCase() || '',
      nserie: data.nserie.toUpperCase() || '',
      kilometrajeAct: data.kilometrajeAct || 0,
      kilometrajeProx: data.kilometrajeProx || 0,
      combustible: data.combustible || 0,
      sintomas: toSentenceCase(data.sintomas) || '',
    },
    servicio: {
      tipo: data.servicio_tipo || '',
      mecanico: data.mecanico_nombre || '',
      mecanico2: data.mecanico2_nombre || '',
      obsMecanico: toSentenceCase(data.obsMecanico) || '',
      observaciones: toSentenceCase(data.observaciones) || '',
      diagnostico: toSentenceCase(data.diagnostico) || '',
      recomendacion: toSentenceCase(data.recomendacion) || '',
      repuestos: data.repuestos,
      ultimaReparacion: toSentenceCase(data.ultimaReparacion) || '',
      empresa: data.empresa || ''
    },
    evaluaciones: data.evaluaciones,
    evidencias: null,
    firmas: {
      cliente: null,
      mecanico: null
    },
  };
}

export default estructurarDatos;
